'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

const serviceNotSet = () => console.error("Error: Tracking service is not correctly configured. Use registerTrackingService before app creation.");
let trackingService = new Proxy({}, {
  get: serviceNotSet
});
function registerTrackingService(service) {
  trackingService = service;
}
function getTrackingService() {
  return trackingService;
}

exports.getTrackingService = getTrackingService;
exports.registerTrackingService = registerTrackingService;
